<template>
  <el-scrollbar class="layout-menu-list" wrap-style="overflow-x: hidden;">
    <draggable
      tag="ul"
      class="link-wrap noselect"
      :list="localList"
      v-bind="dragOptions"
      @change="onSortChange">
      <MenuItem
        v-for="(opt, i) in localList"
        :key="opt.id || opt.url + i"
        :data="opt"
        :remindShow="opt.remindShow" />
    </draggable>
  </el-scrollbar>
</template>

<script>
  import draggable from 'vuedraggable'
  import MenuItem from './menu-item'
  export default {
    props: {
      list: {
        type: Array,
        default: () => ([])
      }
    },
    components: { MenuItem, draggable },
    data () {
      return {
        localList: [],
        dragOptions: {
          draggable: '.menu-item-draggable',
          handle: '.menu-item-draggable',
          animation: 150,
          ghostClass: 'kye-module-ghost'
        }
      }
    },
    watch: {
      list: {
        handler (val) {
          this.localList = [...val]
        },
        immediate: true
      }
    },
    methods: {
      async onSortChange () {
        try {
          const params = this.localList
            .map((item, index) => item.id ? { id: item.id, displaySequence: index + 1 } : null)
            .filter(Boolean)
          if (!params.length) return
          await this.$http('system.homeIndex.setHomeIndexSort', params)
          // this.$emit('update')
          this.$bus.$emit('GLOABL_HOME_UPDATE_MENU')
        } catch (error) {
          console.error(error)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-list {
  flex: 1;
  min-height: 0;
  height: 100%;
  padding-top: 10px;
  /deep/ .el-scrollbar__wrap {
    height: 100%;
    overflow-x: hidden;
  }
  /deep/ .el-scrollbar__bar.is-horizontal {
    display: none;
  }
  .link-wrap {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    justify-content: center;
  }
  .kye-module-ghost {
    background-color: #f5f7ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/common-module-list/menu-list.vue